import React, { useState } from 'react';
import { Eye, EyeOff, Lock } from 'lucide-react';

// Password field with a show/hide toggle, shared by change password, admin
// change password and forgot password. Styled like the login form fields.
const PasswordInput = ({
  id,
  label,
  value,
  onChange,
  onBlur,
  error,
  placeholder,
  autoComplete = 'new-password',
  autoFocus = false,
  disabled = false,
  required = true,
  showIcon = true
}) => {
  const [visible, setVisible] = useState(false);

  return (
    <div style={{ marginBottom: '1.1rem' }}>
      {label && (
        <label htmlFor={id} style={{ display: 'block', fontSize: '0.875rem', fontWeight: 500, color: '#374151', marginBottom: '0.5rem' }}>
          {label}
          {required && <span style={{ color: '#dc2626', marginLeft: '0.25rem' }}>*</span>}
        </label>
      )}
      <div style={{ position: 'relative' }}>
        {showIcon && (
          <Lock
            aria-hidden="true"
            style={{ position: 'absolute', left: '0.75rem', top: '50%', transform: 'translateY(-50%)', width: '1.05rem', height: '1.05rem', color: '#9ca3af' }}
          />
        )}
        <input
          id={id}
          type={visible ? 'text' : 'password'}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          placeholder={placeholder}
          autoComplete={autoComplete}
          autoFocus={autoFocus}
          disabled={disabled}
          aria-invalid={Boolean(error)}
          aria-describedby={error ? `${id}-error` : undefined}
          className="password-input"
          style={{
            width: '100%',
            padding: `0.7rem 2.6rem 0.7rem ${showIcon ? '2.4rem' : '0.75rem'}`,
            border: `1px solid ${error ? '#dc2626' : '#d1d5db'}`,
            borderRadius: '0.6rem',
            fontSize: '0.95rem',
            backgroundColor: error ? '#fef2f2' : disabled ? '#f3f4f6' : 'white',
            boxSizing: 'border-box'
          }}
        />
        <button
          type="button"
          onClick={() => setVisible((v) => !v)}
          aria-label={visible ? 'Hide password' : 'Show password'}
          tabIndex={-1}
          style={{ position: 'absolute', right: '0.75rem', top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', color: '#9ca3af', display: 'flex', padding: 0 }}
        >
          {visible ? <EyeOff size={18} /> : <Eye size={18} />}
        </button>
      </div>
      {error && (
        <div id={`${id}-error`} role="alert" style={{ marginTop: '0.3rem', fontSize: '0.75rem', color: '#dc2626' }}>
          {error}
        </div>
      )}
    </div>
  );
};

export default PasswordInput;
